import React, { useEffect, useState } from "react";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";
import { calcularDesvioPadraoNegativoCusto, calcularDesvioPadraoPositivoCusto, calcularProjecaoCusto } from "../../utils/calculator";
import Tr from "../../common/table/tr";
import Td from "../../common/table/td";
import Table from "../../common/table/table";
import TBody from "../../common/table/tBody";
import Button from "../../common/button/button";
import NumberFormat from "react-number-format";

export function TabelaPrevisorCustos(props) {
    const [percentualCrecimentoAtipico, setPercentualCrecimentoAtipico] = useState(null);
    const projecoes = props.projecoes || [];

    useEffect(() => {
        if (!props.exibirPrevisorCustosMensal) {
            setPercentualCrecimentoAtipico(null);
            props.callback([]);
        }
    }, [props.exibirPrevisorCustosMensal]);

    function getAnoProximaProjecao() {
        const ano = projecoes.length ? projecoes[projecoes.length - 1].ano : props.ultimoAnoCompleto;
        //pode ser 2025 ou no safra 2025/2026
        if (!ano) return "";

        if (String(ano).includes("/")) {
            const anos = String(ano)
                .split("/")
                .map((a) => String(parseInt(a) + 1))
                .join("/");
            return anos;
        }

        return ano + 1;
    }

    function calcularProjecao(percentualCrecimentoAtipico) {
        try {
            if (
                !props.ultimoAnoCompleto ||
                !props.listaCustoMesesAno ||
                !props.listaCustoMesesAno[props.ultimoAnoCompleto] ||
                !props.listaMediaPorMes ||
                !props.listaMediaPorMes.length ||
                !props.listaCoeficienteVariacaoPorMes ||
                !props.listaCoeficienteVariacaoPorMes.length
            )
                return;
            const anoProjecao = getAnoProximaProjecao();
            let listaMeses = projecoes.length ? projecoes[projecoes.length - 1].meses : props.listaCustoMesesAno[props.ultimoAnoCompleto];
            if (percentualCrecimentoAtipico) {
                listaMeses = listaMeses.map((item) => ({
                    ...item,
                    custo_total: getCustoTotalPrevisor(item) * (1 + percentualCrecimentoAtipico / 100),
                }));
            }
            const projecao = {};
            projecao.crescimentoAtipico = !!percentualCrecimentoAtipico;
            projecao.ano = anoProjecao;
            projecao.descricao = `Projeção ${anoProjecao}`;
            projecao.meses = [];
            projecao.desvioNegativo = [];
            projecao.desvioPositivo = [];

            for (const itemMes of listaMeses) {
                let valorProjetado = 0;
                let valorDesvioNegativo = 0;
                let valorDesvioPositivo = 0;
                if (itemMes) {
                    const custoTotalPrevisor = getCustoTotalPrevisor(itemMes);
                    valorProjetado = calcularProjecaoCusto(props.listaMediaPorMes[itemMes.mes - 1], custoTotalPrevisor);
                    valorDesvioNegativo = calcularDesvioPadraoNegativoCusto(props.listaCoeficienteVariacaoPorMes[itemMes.mes - 1], custoTotalPrevisor);
                    valorDesvioPositivo = calcularDesvioPadraoPositivoCusto(props.listaCoeficienteVariacaoPorMes[itemMes.mes - 1], custoTotalPrevisor);
                }
                projecao.meses.push({
                    mes: itemMes.mes,
                    custo_total: valorProjetado,
                    valorDesvioNegativo,
                    valorDesvioPositivo,
                });
                projecao.desvioNegativo.push(valorDesvioNegativo);
                projecao.desvioPositivo.push(valorDesvioPositivo);
            }
            return projecao;
        } catch (erro) {
            console.error(`Não foi possível gerar a projeção de custo. Erro: ${erro}`);
        }
    }

    function getCustoTotalPrevisor(itemMes) {
        if (!itemMes) return 0;
        return parseFloat(itemMes.custo_total || 0);
    }

    if (!props.exibirPrevisorCustosMensal) return null;
    const anoProximaProjecao = getAnoProximaProjecao();
    return (
        <Table resonsive id="tabelaProjecaoCustoMensal">
            <TBody>
                {projecoes.map((p) => {
                    return (
                        <React.Fragment key={p.ano}>
                            <Tr>
                                <Td fontSize="0.75rem" colSpan="13">
                                    <div style={{ height: 10 }}></div>
                                </Td>
                            </Tr>
                            <Tr>
                                <Td width={100} fontSize="0.75rem" alignCenter backgroundColor="#0b2144" color="#ffffff">
                                    {<span>{p.descricao}</span>}
                                </Td>
                                {p.meses.map((itemMes) => (
                                    <Td fontSize="0.75rem" alignCenter backgroundColor="#0b2144" color={p.crescimentoAtipico ? "#ff4f4f" : "#ffffff"}>
                                        {<span className="pl-2">{`R$ ${adicionarPontosMilhar(itemMes.custo_total)}`}</span>}
                                    </Td>
                                ))}
                            </Tr>
                            <Tr>
                                <Td fontSize="0.75rem" alignCenter backgroundColor="#3bbaff" color="#ffffff">
                                    {<span>Desvio Padrão (-)</span>}
                                </Td>
                                {p.desvioNegativo.map((desvioNegativo) => (
                                    <Td fontSize="0.75rem" alignCenter backgroundColor="#3bbaff" color="#ffffff">
                                        {<span className="pl-2">{`R$ ${adicionarPontosMilhar(desvioNegativo)}`}</span>}
                                    </Td>
                                ))}
                            </Tr>
                            <Tr>
                                <Td fontSize="0.75rem" alignCenter backgroundColor="#17ba60" color="#ffffff">
                                    {<span>Desvio Padrão (+)</span>}
                                </Td>
                                {p.desvioPositivo.map((desvioPositivo) => (
                                    <Td fontSize="0.75rem" alignCenter backgroundColor="#17ba60" color="#ffffff">
                                        {<span className="pl-2">{`R$ ${adicionarPontosMilhar(desvioPositivo)}`}</span>}
                                    </Td>
                                ))}
                            </Tr>
                        </React.Fragment>
                    );
                })}
                <Tr className="nao-imprimir">
                    <Td fontSize="0.75rem" colSpan="13">
                        <div style={{ width: "100%", display: "flex" }}>
                            <Button
                                style={{ width: 250, height: 54, margin: "21px 10px 0px 0px" }}
                                type="info"
                                icon="fas fa-plus"
                                disabled={!anoProximaProjecao}
                                text={anoProximaProjecao ? "Gerar Projeção " + anoProximaProjecao : "Sem ano completo para projeção"}
                                event={() => {
                                    const projecao = calcularProjecao(percentualCrecimentoAtipico);
                                    if (!projecao) return;
                                    const novasProjecoes = [...projecoes, projecao];
                                    setPercentualCrecimentoAtipico(null);
                                    props.callback(novasProjecoes);
                                }}
                            />
                            <div style={{ marginTop: 15, color: "#FFF" }}>
                                <div>
                                    <span>Incluir Crescimento Adicional na Média Histórica(%)</span>
                                </div>
                                <NumberFormat
                                    className="form-control"
                                    suffix="%"
                                    disabled={false}
                                    placeholder={"0,00"}
                                    decimalSeparator={","}
                                    decimalScale={2}
                                    fixedDecimalScale={2}
                                    value={String(percentualCrecimentoAtipico || 0).replace(".", ",")}
                                    onValueChange={(values) => {
                                        const valor = values.floatValue || 0;
                                        setPercentualCrecimentoAtipico(valor);
                                    }}
                                />
                            </div>
                        </div>
                    </Td>
                </Tr>
            </TBody>
        </Table>
    );
}
